import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import DeleteAccount from './DeleteAccount';
import TooManyLogIn from './TooManyLogIn';
import verse from './assets/Logo-Verse.svg';
import odience from './assets/Odience-logo-White-Horizontal.svg';
import ProvideOtp from './ProvideOtp';
import { useState } from 'react';
import DeleteConfirmation from './DeleteConfirmation';
import AccountDeleted from './AccountDeleted';
import { Toaster } from "react-hot-toast";

export const enum AppState {
	STATE_INITIAL = 'STATE_INITIAL',
	STATE_PROVIDE_OTP = 'STATE_PROVIDE_OTP',
	STATE_DELETE_CONFIRMATION = 'STATE_DELETE_CONFIRMATION',
	STATE_TOO_MANY_ATTEMPTS = 'STATE_TOO_MANY_ATTEMPTS',
	STATE_ACCOUNT_DELETED = 'STATE_ACCOUNT_DELETED',
};

function App() {

	const [currentState, setCurrentState] = useState<AppState>(AppState.STATE_INITIAL);
	const [phoneNumber, setPhoneNumber] = useState<string>("");
	const changeState = (newState: AppState) => {
		setCurrentState(newState);
	};

	const handleOutput = (output: string) => {
		console.log("Saving phoneNumber for OTP step: ", output)
		setPhoneNumber(output)
	}

	const renderComponent = () => {
		switch (currentState) {
			case AppState.STATE_INITIAL:
				return <DeleteAccount changeState={changeState} handleOutput={handleOutput} />;
			case AppState.STATE_PROVIDE_OTP:
				return <ProvideOtp changeState={changeState} phoneNumber={phoneNumber} />;
			case AppState.STATE_TOO_MANY_ATTEMPTS:
				return <TooManyLogIn changeState={changeState} />;
			case AppState.STATE_DELETE_CONFIRMATION:
				return <DeleteConfirmation changeState={changeState} phoneNumber={phoneNumber} />;
			case AppState.STATE_ACCOUNT_DELETED:
				return <AccountDeleted />;
		}
	};

	return (
		<Router>
			<div className="page-container">
				<div className="logos-container">
					<img src={verse} alt="Verse" className="logo-left"/>
					<img src={odience} alt="Right Logo" className="logo-right"/>
				</div>
				{renderComponent()}
				<p className="footer-text">© VERSE Messages. All rights reserved.</p>
			</div>
			<Toaster toastOptions={{ style: { zIndex: 9999999 } }} />
		</Router>
	);
}

export default App;
